import axios from 'axios'
import { ElMessage } from 'element-plus'
import { useCsNotifyStore } from '@/stores/cs-notify'
import { useFinancePendingNotifyStore } from '@/stores/finance-pending-notify'

function formatRequestError(error) {
  if (!error.response) {
    if (error.code === 'ECONNABORTED' || /timeout/i.test(error.message || '')) {
      return '请求超时，请稍后重试'
    }
    if (error.message === 'Network Error' || /Network Error/i.test(error.message || '')) {
      return '网络连接失败，请检查网络或服务是否可用'
    }
  }
  return error.message || '网络错误'
}

// 创建 axios 实例
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '',
  timeout: 30000
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 获取 token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    ElMessage.error(formatRequestError(error))
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data

    // 如果返回的状态码不是 0，说明出错了
    if (res.code !== 0) {
      ElMessage.error(res.msg || res.message || '请求失败')

      // 401: Token 过期或无效
      if (res.code === 401) {
        try {
          useCsNotifyStore().teardown()
          useFinancePendingNotifyStore().teardown()
        } catch (_) {}
        localStorage.removeItem('token')
        window.location.href = '/login'
      }

      return Promise.reject(new Error(res.msg || res.message || '请求失败'))
    }

    return res.data
  },
  error => {
    // 处理 HTTP 错误状态码
    if (error.response) {
      const { status, data } = error.response

      // 403: IP被黑名单拦截
      if (status === 403) {
        const msg = data?.message || '访问被拒绝'
        ElMessage.error(msg)
        return Promise.reject(new Error(msg))
      }

      // 401: 未授权
      if (status === 401) {
        ElMessage.error('登录已过期，请重新登录')
        try {
          useCsNotifyStore().teardown()
          useFinancePendingNotifyStore().teardown()
        } catch (_) {}
        localStorage.removeItem('token')
        window.location.href = '/login'
        return Promise.reject(new Error('登录已过期'))
      }
    }

    const msg = formatRequestError(error)
    ElMessage.error(msg)
    return Promise.reject(error)
  }
)

export default request
